module.exports = __webpack_public_path__ + "static/ilustracao-solucoes-complementares-0091ec9a16b9bcfcc8a62b0e7c720766.svg";